
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AgGridModule } from 'ag-grid-angular';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MaterialModule } from 'src/app/material-module';
import { BaseComponent } from './components/base/base.component';
import { ManageRolePermissionExpandableComponent } from './components/manage-role-permission-expandable/manage-role-permission-expandable.component';
import { TreeMultiSelectDropdownComponent } from './components/tree-multi-select-dropdown/tree-multi-select-dropdown.component';
import { TreeSelectDropdownComponent } from './components/tree-select-dropdown/tree-select-dropdown.component';
import { UserProfileComponent } from './components/user-profile/user-profile.component';
import { PermissionGuard } from './guards/permission.guard';
import { EnumToArrayPipe } from './pipes/enum-to-array.pipe';
import { PermissionCheckerPipe } from './pipes/permission-checker.pipe';
import { ReverseRenderingListPipe } from './pipes/reverse-rendering-list.pipe';
import { StringToArrayPipe } from './pipes/string-to-array.pipe';
import { BreadCrumbComponent } from './components/bread-crumb/bread-crumb.component';

import { BooleanViewComponent } from './components/boolean-view/boolean-view.component';
import { CommonModule } from '@angular/common';
import { AvatarModule } from 'ngx-avatar';

const avatarColors = ["#FFB6C1", "#2c3e50", "#95a5a6", "#f39c12", "#1abc9c"];
const PIPES = [EnumToArrayPipe, StringToArrayPipe, ReverseRenderingListPipe, PermissionCheckerPipe];
const COMPONENTS = [BaseComponent, TreeSelectDropdownComponent, TreeMultiSelectDropdownComponent, ManageRolePermissionExpandableComponent, UserProfileComponent, BreadCrumbComponent, BooleanViewComponent];
const MODULES = [FormsModule, ReactiveFormsModule, RouterModule, AgGridModule, MaterialModule, NgxSpinnerModule];
const GUARDS = [PermissionGuard]
@NgModule({
  imports: [
    CommonModule,
    ...MODULES,
    AvatarModule.forRoot({
      colors: avatarColors
    })
  ],
  declarations: [...COMPONENTS, ...PIPES],
  exports: [...COMPONENTS, ...PIPES, ...MODULES, AvatarModule],
  providers: [...GUARDS]
})
export class SharedModule { }
